"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClickableAreaStyled = exports.PulseHotspotContainer = exports.SvgContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _hotspot = require("../../hotspot.constants");

var _hotspotGlobal = require("../../hotspot.global.styles");

var _boundingBox = require("../../components/bounding-box");

var _hotspot2 = _interopRequireDefault(require("../../hotspot.styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var PulseAnimation = (0, _styledComponents.keyframes)(["0%{r:0;opacity:1;}30%{r:0;opacity:1;}100%{r:50%;opacity:0;}"]); // $FlowFixMe

var SvgContainer = _styledComponents.default.div.attrs(function (_ref) {
  var iconPosition = _ref.iconPosition;
  return {
    style: {
      left: "".concat(iconPosition.left, "%"),
      top: "".concat(iconPosition.top, "%")
    }
  };
}).withConfig({
  displayName: "Pulsestyles__SvgContainer",
  componentId: "sc-3vwbge-0"
})(["height:40px;position:absolute;transform:", ";width:40px;"], _hotspotGlobal.translateXY);

exports.SvgContainer = SvgContainer;

var PulseHotspotContainer = _styledComponents.default.div.withConfig({
  displayName: "Pulsestyles__PulseHotspotContainer",
  componentId: "sc-3vwbge-1"
})(["cursor:pointer;height:100%;width:100%;opacity:", ";.pulse-svg{circle{animation:", " 2000ms infinite;&.circle-2{animation-delay:300ms;}&.circle-3{animation-delay:600ms;}&.circle-4{animation-delay:900ms;}}}"], function (_ref2) {
  var config = _ref2.config;
  return config.opacity;
}, PulseAnimation);

exports.PulseHotspotContainer = PulseHotspotContainer;
var hoverState = "\n  ".concat(_boundingBox.FourCornersStyled, " {\n    opacity: 1;\n  }\n  ").concat(SvgContainer, " {\n    opacity: 0;\n  }\n");
var ClickableAreaStyled = (0, _styledComponents.default)(_hotspot2.default).withConfig({
  displayName: "Pulsestyles__ClickableAreaStyled",
  componentId: "sc-3vwbge-2"
})(["", ""], function (_ref3) {
  var disableHover = _ref3.disableHover;
  return !disableHover && (0, _styledComponents.css)(["&:hover,&", "{", ";}", ""], _hotspot.focusVisible, hoverState, function (_ref4) {
    var previewHoverState = _ref4.previewHoverState;
    return previewHoverState && hoverState;
  });
});
exports.ClickableAreaStyled = ClickableAreaStyled;